import React from "react";
import Sidebar from "components/Sidebar";
import { stepsByName } from "../specificUtils/configs";

export default function SidebarWrapper(props) {
  return (
    <Sidebar
      groupTitle="Durata permanenza"
      packageTitle="Periodo di partenza"
      departureTitle="Città di partenza"
      enableTagManager
      onNext={props.onNext}
      sendBookingButtonLabel={props.sendBookingButtonLabel}
      isSubmitting={props.isSubmitting}
      stepsByName={stepsByName}
    />
  );
}
